@import "../../../global/gx-ide-common.scss";
@import "../../../global/gx-ide-mixins.scss";
@import "../../../global/temporary-tokens-chameleon.scss";

:host {
  display: block;
}

.main {
  display: grid;
  grid-template-rows: 1fr auto;
  block-size: 100%;
  gap: var(--spacing-gap-l);
}
.path-list {
  inline-size: 100%;
  block-size: 100%;
}
gx-ide-list-selector::part(list) {
  block-size: 100%;
}
.hidden-input {
  display: none;
}
.checkbox-container {
  display: flex;
  gap: var(--spacing-gap-m);
}
.footer {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-gap-l);
}
